import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class UsersService extends BaseService {
  static get entity() {
    return 'managers'
  }

  static async getCurrent() {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/profile`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
